import axios from 'axios';
import React, { useState, useEffect } from 'react';
import { Spinner } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { endpoint } from '../../api';
import appConfig from '../../appConfig';
import RecipientListTable from './RecipientListTable';

const RecipientList = () => {
  const navigate = useNavigate();
  const userDetails = useSelector((state) => state?.user?.userDetails);
  const [isLoading, setIsLoading] = useState(false);
  const [SuccessMessage, setSuccessMessage] = useState();
  const [siteLocations, setSiteLocations] = useState([]);
  const [assignedAlarm, setAssignedAlarm] = useState([]);
  const [users, setUsers] = useState([]);
  const [notifications, setNotifications] = useState([]);
  const [AssignAlarmEx, setAssignAlarmEx] = useState({
    name: '',
    email: '',
    role: '',
    user: '',
    site: '',
    alarm: '',
    isActive: true,
  });
  const { site, role, alarm } = AssignAlarmEx;

  const onInputChange = (e) => {
    setAssignAlarmEx({ ...AssignAlarmEx, [e.target.name]: e.target.value });
  };

  const handleUserChange = (e) => {
    let user = users.filter((item) => item._id === e.target.value);
    setAssignAlarmEx({
      ...AssignAlarmEx,
      user: e.target.value,
      name: user[0]?.name,
      email: user[0]?.email,
    });
  };

  const getSiteLocations = async (userDetails) => {
    if (userDetails.role === 'superAdmin') {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/site-location`, { withCredentials: true });
      if (response) {
        setSiteLocations(response.data.sort((a, b) => (a?.createdAt < b?.createdAt ? 1 : -1)));
      }
    } else if (userDetails.role === 'admin') {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/site-location/admin-sites/` + userDetails._id,
        { withCredentials: true }
      );
      if (response) {
        setSiteLocations(response.data.sort((a, b) => (a.createdAt < b.createdAt ? 1 : -1)));
      }
    } else if (userDetails.role === 'installer') {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/site-location/installer-sites/` + userDetails._id,
        { withCredentials: true }
      );
      if (response) {
        setSiteLocations(response.data.sort((a, b) => (a.createdAt < b.createdAt ? 1 : -1)));
      }
    } else if (userDetails.role === 'user') {
      let site = [];
      site.push(userDetails.site);
      setSiteLocations(site);
    } else if (userDetails.role === 'public') {
      let site = [];
      site.push(userDetails.site);
      setSiteLocations(site);
    }
  };
  const getNotifications = async (site) => {
    axios
      .get(endpoint.notification, {
        params: { site: site, page: 1, limit: 99999 },
        withCredentials: true,
      })
      .then((res) => setNotifications(res.data?.results));
  };

  useEffect(() => {
    if (site) {
      getNotifications(site);
    }
    // eslint-disable-next-line
  }, [site]);

  const getUsers = async () => {
    const response = await axios.get(`${process.env.REACT_APP_API_URL}/user/siteUser/${site}/${role}`, {
      withCredentials: true,
    });
    if (response) {
      setUsers(response.data);
    }
  };
  useEffect(() => {
    if (role !== 'external' && site) {
      getUsers();
    }
    // eslint-disable-next-line
  }, [site, role]);

  const getAssignedAlarm = async () => {
    const response = await axios.get(`${endpoint.notification_v1}/assign`, { withCredentials: true });
    if (response) {
      setAssignedAlarm(response.data);
    }
  };
  useEffect(() => {
    document.title = `${appConfig.name} - Recipient List`;
    getAssignedAlarm();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    getSiteLocations(userDetails);
    // eslint-disable-next-line
  }, [userDetails]);

  const handleSubmitEx = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    const response = await axios.post(`${endpoint.notification}/assign`, AssignAlarmEx, {
      withCredentials: true,
    });
    if (response) {
      setIsLoading(false);
      setSuccessMessage('Alarm Assign Successfully');
      getAssignedAlarm();
      setAssignAlarmEx({
        name: '',
        email: '',
        role: 'external',
        site: '',
        alarm: '',
        isActive: true,
      });
      setTimeout(() => {
        setSuccessMessage();
        // window.location.reload(false);
      }, 2000);
    }
  };

  return (
    <div className="settings">
      <div className="card p-3 m-3">
        <div className="d-flex align-items-center justify-content-between">
          <div>
            <label className="az-content-label">Manage Alarm</label>
            <span className="d-block py-2">Notification Recipient List</span>
          </div>
          <div className="col-md-4 d-flex justify-content-end p-0">
            <button className="btn btn-az-primary btn-md" to="/site-locations/create" onClick={() => navigate(-1)}>
              Back
            </button>
          </div>
        </div>
        <hr className="mt-0" />

        {/* <Link className="btn btn-secondary float-end" onClick={() => navigate(-1)}>
              Back
            </Link> */}

        <div className="row">
          <div className="col-md-6">
            {/* <h3>Notification Recipient List</h3> */}

            <div className="d-flex justify-content-center">
              {isLoading && <Spinner animation="border" variant="dark" />}
            </div>
            {SuccessMessage && (
              <div className="alert alert-success" role="alert">
                {SuccessMessage}{' '}
              </div>
            )}
          </div>
          {/* <div className="col-md-6 ">

          </div> */}
        </div>
        <div className="row mt-3">
          <div className="col-md-6 border-end">
            <h5>Assign Existing System User Accounts</h5>
            <form onSubmit={handleSubmitEx}>
              <div className="row">
                <div className="col-md-4">
                  <label htmlFor="site" className="form-label">
                    Site Location
                  </label>
                  <select name="site" id="site" value={site} className="form-select" onChange={onInputChange}>
                    <option value="" disabled>
                      Select Site
                    </option>
                    {siteLocations &&
                      siteLocations.length > 0 &&
                      siteLocations.map((item, index) => (
                        <option value={item._id} key={index}>
                          {item.name}
                        </option>
                      ))}
                  </select>
                </div>
                <div className="col-md-4">
                  <label htmlFor="role" className="form-label">
                    User Type
                  </label>
                  <select name="role" id="role" value={role} className="form-select" onChange={onInputChange}>
                    <option value="" disabled>
                      Select Role
                    </option>
                    <option value="admin">Admin</option>
                    <option value="installer">Installer</option>
                    <option value="user">Site User</option>
                    <option value="public">Site Public</option>
                  </select>
                </div>
                <div className="col-md-4">
                  <label htmlFor="user" className="form-label">
                    Site User
                  </label>
                  <select
                    name="user"
                    id="user"
                    className="form-select"
                    value={AssignAlarmEx.user}
                    onChange={handleUserChange}
                  >
                    <option value="" disabled>
                      Select User
                    </option>
                    {users?.length > 0 &&
                      users.map((item, index) => (
                        <option value={item._id} key={item._id}>
                          {item.name}
                        </option>
                      ))}
                  </select>
                </div>
              </div>
              <div className="row mt-2">
                <div className="col-md-4">
                  <label htmlFor="alarm" className="form-label">
                    Alarm Name
                  </label>
                  <select name="alarm" id="alarm" value={alarm} className="form-select" onChange={onInputChange}>
                    <option value="" disabled>
                      Select Alarm
                    </option>
                    {notifications &&
                      notifications.length > 0 &&
                      notifications.map((item, index) => (
                        <option value={item._id} key={index}>
                          {item.name}
                        </option>
                      ))}
                  </select>
                </div>
                <div className="col-md-8">
                  <button type="submit" className="btn btn-success mt-4 float-end">
                    Assign
                  </button>
                </div>
              </div>
            </form>
          </div>
          <div className="col-md-6">
            <h5>Assign Email Address (External Accounts)</h5>
            <form onSubmit={handleSubmitEx}>
              <div className="row">
                <div className="col-md-4">
                  <label htmlFor="site" className="form-label">
                    Site Location
                  </label>
                  <select name="site" id="site" value={site} className="form-select" onChange={onInputChange}>
                    <option value="" disabled>
                      Select Site
                    </option>
                    {siteLocations &&
                      siteLocations.length > 0 &&
                      siteLocations.map((item, index) => (
                        <option value={item._id} key={index}>
                          {item.name}
                        </option>
                      ))}
                  </select>
                </div>
                <div className="col-md-4">
                  <label htmlFor="name" className="form-label">
                    Full Name
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    name="name"
                    placeholder="Enter Full Name"
                    onChange={onInputChange}
                  />
                </div>
                <div className="col-md-4">
                  <label htmlFor="email" className="form-label">
                    Email Address
                  </label>
                  <input
                    type="email"
                    className="form-control"
                    name="email"
                    placeholder="Enter Email Address"
                    onChange={onInputChange}
                  />
                </div>
              </div>
              <div className="row mt-2">
                <div className="col-md-4">
                  <label htmlFor="alarm" className="form-label">
                    Alarm Name
                  </label>
                  <select name="alarm" id="alarm" value={alarm} className="form-select" onChange={onInputChange}>
                    <option value="" disabled>
                      Select Alarm
                    </option>
                    {notifications &&
                      notifications.length > 0 &&
                      notifications.map((item, index) => (
                        <option value={item._id} key={index}>
                          {item.name}
                        </option>
                      ))}
                  </select>
                </div>
                <div className="col-md-8">
                  <button type="submit" className="btn btn-success mt-4 float-end">
                    Assign
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
        <hr />

        <RecipientListTable data={assignedAlarm} siteLocations={siteLocations} getAssignedAlarm={getAssignedAlarm} />
      </div>
    </div>
  );
};

export default RecipientList;
